import { SimpleLineIcons } from "@expo/vector-icons";
import { Badge, useTheme } from "native-base";
import React from "react";
import { Text, View } from "react-native";

import { Scale } from "../constants";
import { isUserDiy } from "../helpers/userHelpers";
import type { CalendarDay, User } from "../services/backendTypes";

interface NoteComponentProps {
  currentCalendarDay: CalendarDay | undefined;
  user: User | null;
  onPressNote: () => void;
}

const NoteComponent = ({ currentCalendarDay, user, onPressNote }: NoteComponentProps): JSX.Element => {
  const theme = useTheme();

  return (
    <View style={{ flex: 1, flexDirection: "row-reverse", marginHorizontal: Scale(4) }}>
      {currentCalendarDay && currentCalendarDay.note ? (
        <Badge colorScheme="primary" zIndex={1} variant="solid" alignSelf="flex-end" ml="2">
          <Text>{"1"}</Text>
        </Badge>
      ) : null}

      {user && isUserDiy(user) ? null : (
        <SimpleLineIcons
          name="note"
          size={24}
          color={theme.colors.primary["600"]}
          onPress={onPressNote}
          testID="add-note-button"
          style={{ marginLeft: Scale(8) }}
        />
      )}
    </View>
  );
};

export default NoteComponent;
